const ActionTypes = {
  // General
  SHOW_ALERT: "SHOW_ALERT",
  HIDE_ALERT: "HIDE_ALERT",
  SHOW_RINGING: "SHOW_RINGING",
  HIDE_RINGING: "HIDE_RINGING",
  DECLINE_RINGING: "DECLINE_RINGING",
  SHOW_LOADING: "SHOW_LOADING",
  HIDE_LOADING: "HIDE_LOADING",
  GENERAL_TYPES: "GENERAL_TYPES",
  UPDATE_TYPES: "UPDATE_TYPES",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  //DASHBOAD
  GET_DEALER_DASHBOARD: "GET_DEALER_DASHBOARD",
  // User
  GET_USER: "GET_USER",
  IsLogin: "IsLogin",
  IsLogout: "IsLogout",
  IsReset: "IsReset",
  EmailNotification: "EmailNotification",

  //Assets
  GET_SINGLE_ASSETS: "GET_SINGLE_ASSETS",
  RESET_SINGLE_ASSETS: "RESET_SINGLE_ASSETS",
  SET_ASSETS_STATUS: "SET_ASSETS_STATUS",
  GET_UNLINK_ASSETS: "GET_UNLINK_ASSETS",
  RESET_UNLINK_ASSETS: "RESET_UNLINK_ASSETS",
  UPLOAD_ASSETE_COLUMNS: "UPLOAD_ASSETE_COLUMNS",
  GET_VAUTO_ASSETS: "GET_VAUTO_ASSETS",
  GET_PENDING_ASSETS: "GET_PENDING_ASSETS",

  //Modules
  RESET_UNLINK_MODULES: "RESET_UNLINK_MODULES",
  GET_UNLINK_MODULES: "GET_UNLINK_MODULES",
  DLT_MODULE_FROM_ASSET: "DLT_MODULE_FROM_ASSET",
  GET_MODULES: "GET_MODULES",
  RESET_MODULES: "RESET_MODULES",
  //Pages
  GET_PAGES: "GET_PAGES",

  //Schedule
  GET_SCHEDULE: "GET_SCHEDULE",

  //Group Assets
  GET_GROUP_ASSETS: "GET_GROUP_ASSETS",
  RESET_GROUP_ASSETS: "RESET_GROUP_ASSETS",
  SET_ASSETS_GROUP_STATUS: "SET_ASSETS_GROUP_STATUS",
  SET_STATUS_OF_GROUP_ASSET: "SET_STATUS_OF_GROUP_ASSET",
  GROUP_ASSET_DETAILS: "GROUP_ASSET_DETAILS",
  GET_GROUP_VEHICLES_BY_ID: "GET_GROUP_VEHICLES_BY_ID",
  GET_GROUP_VEHICLE_DETAILS: "GET_GROUP_VEHICLE_DETAILS",

  //Chats
  GET_CHATS: "GET_CHATS",
  CLEAR_CHATS: "CLEAR_CHATS",
  UPDATE_CHATS: "UPDATE_CHATS",

  //LORAWAN
  GET_LORAWAN: "GET_LORAWAN",
  RESET_LORAWAN: "RESET_LORAWAN",

  //NOTIFICATIONS
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  RESET_NOTIFICATIONS: "RESET_NOTIFICATIONS",

  GET_UNREAD_NOTIFICATIONS: "GET_UNREAD_NOTIFICATIONS",
  RESET_UNREAD_NOTIFICATIONS: "RESET_UNREAD_NOTIFICATIONS",

  //STAFF
  GET_STAFF: "GET_STAFF",
  RESET_STAFF: "RESET_STAFF",

  //LICENSE MANAGEMENT
  GET_LICENSE: "GET_LICENSE",
  RESET_LICENSE: "RESET_LICENSE",

  //SALES HISTORY
  SALES_HISTORY: "SALES_HISTORY",

  /////////////////////////////////////////////////////////////////////////Customer////////////////////////////////////////////////////

  //DASHBOARD
  GET_CUS_DASHBOARD: "GET_CUS_DASHBOARD",

  //MODULES
  GET_CUS_MODULES: "GET_CUS_MODULES",
  GET_CUS_MODULE_DETAILS: "GET_CUS_MODULE_DETAILS",

  //ASSETS
  GET_CUS_ASSETS: "GET_CUS_ASSETS",
  GET_CUS_ASSET_DETAIL: "GET_CUS_ASSET_DETAIL",
  SET_CUS_ASSETS_STATUS: "SET_CUS_ASSETS_STATUS",
  CUS_GET_UNLINK_ASSETS: "CUS_GET_UNLINK_ASSETS",

  // LOGS
  LOGS: "LOGS",

  // LOT NUMBER
  GET_LOT_NUMBER: "GET_LOT_NUMBER",

  // COMPANY
  COMPANY: "COMPANY",
  GET_CUSTOMER: "GET_CUSTOMER",
  RESET_CUSTOMER: "RESET_CUSTOMER",
  GET_DEALERSHIP: "GET_DEALERSHIP",
  RESET_DEALERSHIP: "RESET_DEALERSHIP",
};

export default ActionTypes;
